export const wait = (ms: number) => new Promise<void>((resolve) => setTimeout(() => resolve(), ms));

export const deduplicatePendingRequests = <P, R>(
  request: (params: P) => Promise<R>,
  getKey: (params: P) => string
): ((params: P) => Promise<R>) => {
  const pendingRequests = new Map<string, Promise<R>>();

  return (params: P) => {
    const key = getKey(params);
    const pendingRequest = pendingRequests.get(key);
    if (pendingRequest) {
      return pendingRequest;
    }

    const currentRequest = request(params);
    pendingRequests.set(key, currentRequest);
    const clearPendingRequest = () => {
      if (pendingRequests.get(key) === currentRequest) {
        pendingRequests.delete(key);
      }
    };
    void currentRequest.then(clearPendingRequest, clearPendingRequest);

    return currentRequest;
  };
};
